(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var categorySelect = document.getElementById('ContactForm-category');
    var customCategoryInput = document.getElementById('ContactForm-category-custom');

    function syncCustomCategoryVisibility() {
      if (!categorySelect || !customCategoryInput) return;
      var showCustom = categorySelect.value === 'Other (please specify)';
      customCategoryInput.classList.toggle('is-visible', showCustom);
    }

    if (categorySelect) {
      categorySelect.addEventListener('change', syncCustomCategoryVisibility);
      syncCustomCategoryVisibility();
    }

    var contactForm = document.querySelector('.contact-form__form');
    var bodyField = document.getElementById('ContactForm-body');
    var fieldsWrapper = document.querySelector('[data-contact-form-fields]');
    var thankyouPanel = document.querySelector('[data-contact-form-thankyou]');
    var resetButton = document.querySelector('[data-contact-form-reset]');
    var errorBanner = document.querySelector('[data-contact-form-error]');
    var errorBannerText = document.querySelector('[data-contact-form-error-text]');
    var errorHideTimeout = null;
    var ERROR_TRANSITION_MS = 220;
    var GENERIC_ERROR_MESSAGE = (errorBanner && errorBanner.getAttribute('data-msg-required')) || 'Please fill in the highlighted boxes.';

    if (contactForm) {
      // Take over validation ourselves so the browser's default
      // "Please fill out this field" bubble never shows.
      contactForm.noValidate = true;
    }

    // The fields start disabled (see the <fieldset disabled> in the markup)
    // so it's physically impossible to click Send before this script has
    // run and attached the real submit handler below. The instant this
    // line runs, the form becomes usable -- and by then the listener a
    // few lines down is already wired up, so there's no gap where a
    // click could fall through to a plain native page submit.
    if (fieldsWrapper) {
      fieldsWrapper.disabled = false;
    }

    var validationRules = [
      { id: 'ContactForm-name' },
      { id: 'ContactForm-email' },
      { id: 'ContactForm-category' },
      { id: 'ContactForm-subject' },
      { id: 'ContactForm-body' }
    ];

    function isCategoryCustomRequired() {
      return categorySelect && categorySelect.value === 'Other (please specify)';
    }

    function clearFieldError(field) {
      field.classList.remove('contact-form__input--invalid');
    }

    function markFieldInvalid(field) {
      field.classList.add('contact-form__input--invalid');
    }

    function hideFormError() {
      if (!errorBanner || errorBanner.hidden) return;
      if (errorHideTimeout) clearTimeout(errorHideTimeout);
      errorBanner.classList.remove('is-visible');
      errorHideTimeout = setTimeout(function () {
        errorBanner.hidden = true;
      }, ERROR_TRANSITION_MS);
    }

    function showFormError() {
      if (!errorBanner) return;
      if (errorHideTimeout) {
        clearTimeout(errorHideTimeout);
        errorHideTimeout = null;
      }
      if (errorBannerText) errorBannerText.textContent = GENERIC_ERROR_MESSAGE;
      errorBanner.hidden = false;
      // Force reflow so the transition reliably plays every time.
      void errorBanner.offsetWidth;
      errorBanner.classList.add('is-visible');
    }

    function anyFieldStillInvalid() {
      return validationRules.some(function (rule) {
        if (rule.id === 'ContactForm-category-custom' && !isCategoryCustomRequired()) {
          return false;
        }
        var field = document.getElementById(rule.id);
        return field && field.classList.contains('contact-form__input--invalid');
      });
    }

    validationRules.forEach(function (rule) {
      var field = document.getElementById(rule.id);
      if (!field) return;
      var eventName = field.tagName === 'SELECT' ? 'change' : 'input';
      field.addEventListener(eventName, function () {
        if (field.checkValidity()) {
          clearFieldError(field);
          if (!anyFieldStillInvalid()) hideFormError();
        }
      });
    });

    if (customCategoryInput) {
      customCategoryInput.addEventListener('input', function () {
        if (customCategoryInput.value.trim()) {
          clearFieldError(customCategoryInput);
          if (!anyFieldStillInvalid()) hideFormError();
        }
      });
    }

    var wrapper = contactForm ? contactForm.closest('.contact-form') : null;
    var submitButton = contactForm ? contactForm.querySelector('[type="submit"]') : null;
    var FAILED_MESSAGE = (errorBanner && errorBanner.getAttribute('data-msg-failed')) || 'Something went wrong sending your message. Please try again.';
    var nativeSubmit = HTMLFormElement.prototype.submit;
    var sending = false;
    var composedBody = null;

    // Shopify protects contact forms with hCaptcha. Its scripts catch the
    // submit event and, once the (invisible) captcha has passed, call
    // form.submit() -- a native submit that reloads the whole page. That is
    // what used to happen. The hCaptcha script picks up whatever
    // form.submit is when it attaches (on the first focus inside the form),
    // and the fields stay disabled until this script has run, so replacing
    // form.submit here means that final step sends the message in the
    // background instead, captcha token included, and the page never
    // reloads.
    if (contactForm) {
      contactForm.removeAttribute('target');
      try {
        contactForm.submit = function () {
          sendInBackground();
        };
      } catch (e) {}
    }

    // The formatted email body travels in a hidden field, so the visible
    // message box always keeps exactly what the customer typed.
    if (contactForm && bodyField) {
      composedBody = document.createElement('input');
      composedBody.type = 'hidden';
      composedBody.name = bodyField.getAttribute('name') || 'contact[body]';
      bodyField.removeAttribute('name');
      contactForm.appendChild(composedBody);
    }

    function clearAllFieldErrors() {
      validationRules.concat([{ id: 'ContactForm-category-custom' }]).forEach(function (rule) {
        var field = document.getElementById(rule.id);
        if (field) clearFieldError(field);
      });
    }

    function hideFormErrorNow() {
      if (!errorBanner) return;
      if (errorHideTimeout) clearTimeout(errorHideTimeout);
      errorBanner.classList.remove('is-visible');
      errorBanner.hidden = true;
    }

    function setSending(isSending) {
      sending = isSending;
      if (!contactForm) return;
      contactForm.classList.toggle('is-sending', isSending);
      if (submitButton) {
        if (isSending) submitButton.setAttribute('aria-busy', 'true');
        else submitButton.removeAttribute('aria-busy');
      }
    }

    function showThankyou() {
      if (fieldsWrapper) fieldsWrapper.hidden = true;
      if (wrapper) wrapper.classList.add('is-sent');
      if (thankyouPanel) {
        thankyouPanel.hidden = false;
        try { thankyouPanel.focus({ preventScroll: true }); } catch (e) { thankyouPanel.focus(); }
        var rect = (wrapper || thankyouPanel).getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight) {
          (wrapper || thankyouPanel).scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    function showFields() {
      if (thankyouPanel) thankyouPanel.hidden = true;
      if (wrapper) wrapper.classList.remove('is-sent');
      if (fieldsWrapper) fieldsWrapper.hidden = false;
      syncCustomCategoryVisibility();
    }

    function finishSent() {
      setSending(false);
      hideFormErrorNow();
      if (contactForm) contactForm.reset();
      clearAllFieldErrors();
      syncCustomCategoryVisibility();
      showThankyou();
    }

    function finishFailed() {
      setSending(false);
      showFields();
      if (errorBannerText) errorBannerText.textContent = FAILED_MESSAGE;
      if (errorBanner) {
        if (errorHideTimeout) clearTimeout(errorHideTimeout);
        errorBanner.hidden = false;
        void errorBanner.offsetWidth;
        errorBanner.classList.add('is-visible');
      }
    }

    function sendInBackground() {
      if (!contactForm || sending) return;
      setSending(true);

      fetch(contactForm.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(contactForm),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          var url = response.url || '';
          if (/\/challenge/.test(url)) {
            // Shopify wants a manual "are you human" check. Only then fall
            // back to a normal submit, so the customer can solve it; after
            // that Shopify returns to this page with the thank-you box shown.
            setSending(false);
            nativeSubmit.call(contactForm);
            return;
          }
          return response.text().then(function (html) {
            var failed = !response.ok || html.indexOf('data-contact-form-server-error') !== -1;
            if (!failed) {
              finishSent();
            } else {
              finishFailed();
            }
          });
        })
        .catch(function (error) {
          console.error('Contact form submission failed:', error);
          finishFailed();
        });
    }

    function handleSubmit(event) {
      if (!contactForm || event.target !== contactForm) return;

      if (sending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      hideFormError();

      var hasInvalidField = false;
      var firstInvalidField = null;

      validationRules.forEach(function (rule) {
        var field = document.getElementById(rule.id);
        if (!field) return;

        if (field.checkValidity()) {
          clearFieldError(field);
        } else {
          markFieldInvalid(field);
          hasInvalidField = true;
          if (!firstInvalidField) firstInvalidField = field;
        }
      });

      if (isCategoryCustomRequired() && customCategoryInput && !customCategoryInput.value.trim()) {
        markFieldInvalid(customCategoryInput);
        hasInvalidField = true;
        if (!firstInvalidField) firstInvalidField = customCategoryInput;
      } else if (customCategoryInput) {
        clearFieldError(customCategoryInput);
      }

      if (hasInvalidField) {
        // Stop here AND stop Shopify's spam-check script, which would
        // otherwise send the incomplete form anyway.
        event.preventDefault();
        event.stopImmediatePropagation();
        showFormError();
        if (firstInvalidField) firstInvalidField.focus();
        return;
      }

      var subjectField = document.getElementById('ContactForm-subject');
      var subject = subjectField ? subjectField.value.trim() : '';
      var category = categorySelect ? categorySelect.value : '';
      var customCategory = customCategoryInput ? customCategoryInput.value.trim() : '';
      var message = bodyField ? bodyField.value.trim() : '';

      // Name, email and phone are already shown by Shopify's own
      // notification header, so we don't repeat them here.
      var lines = [];
      if (subject) lines.push('<strong>Subject:</strong> ' + subject);
      if (category === 'Other (please specify)' && customCategory) {
        lines.push('<strong>Category:</strong> ' + customCategory);
      } else if (category) {
        lines.push('<strong>Category:</strong> ' + category);
      }
      lines.push('---');
      lines.push('<strong>Message:</strong>');
      lines.push(message);
      lines.push('---');
      lines.push('Sent via the Contact Form');

      if (composedBody) composedBody.value = lines.join('\n');

      // Nothing is sent yet: Shopify's hCaptcha script runs next and calls
      // form.submit() (our background send) once the captcha has passed.
    }

    // Safety net, runs after every other submit listener: if nobody took
    // over the submit (e.g. the captcha script did not load), stop the
    // native page reload and send in the background ourselves.
    function handleSubmitFallback(event) {
      if (!contactForm || event.target !== contactForm) return;
      if (event.defaultPrevented) return;
      event.preventDefault();
      sendInBackground();
    }

    // Capture phase on window: runs before Shopify's document-level
    // listener and before anything bound on the form itself.
    window.addEventListener('submit', handleSubmit, true);
    window.addEventListener('submit', handleSubmitFallback, false);

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (contactForm) contactForm.reset();
        clearAllFieldErrors();
        hideFormErrorNow();
        showFields();
        if (/[?&]contact_posted=true/.test(window.location.search) && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.hash);
        }
        var first = document.getElementById('ContactForm-name');
        if (first) {
          try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["moky-contact-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-moky-copy]').forEach(function (button) {
    button.addEventListener('click', function () {
      var label = button.querySelector('[data-moky-copy-label]');
      var value = button.getAttribute('data-moky-copy');
      if (!navigator.clipboard || !value) {
        window.location.href = 'mailto:' + value;
        return;
      }
      navigator.clipboard.writeText(value).then(function () {
        if (!label) return;
        var original = label.textContent;
        label.textContent = button.getAttribute('data-moky-copied') || 'Copied';
        setTimeout(function () { label.textContent = original; }, 1600);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
